export const ACCOUNT_MANAGER = 'ACCOUNT_MANAGER';
export const BILLING = 'BILLING';
export const CONTRACT_MANAGER = 'CONTRACT_MANAGER';
export const DELIVERABILITY = 'DELIVERABILITY';
export const PAYMENT = 'PAYMENT';
export const PRIVACY = 'PRIVACY';
export const SECURITY = 'SECURITY';